<template>
    <div>

      <ed-modal 
			  :title="(certificado ? certificado.tipo_certificado_nome+' - '+certificado.representante : '')"
        :modal="showFormEdit" 
        :loadingSave="loadingSave"
        :onSave="salvar"
        width="70%"
		>
			<div slot="modal-content">
          <el-form label-position="top" label-width="100px" :model="formData" ref="ruleForm">

            <div class="row">

              <div class="form-group col-md-12">

                  <el-form-item label="INSERIR NOVO VÍNCULO"
                      prop="empresa"
                      :rules="[
                          { required: false, message: 'Campo Obrigatorio'},
                      ]"
                      :class="error['empresa']? 'is-error' : ''"
                    >
                      <el-select
                            v-model="formData.empresa"
                            filterable
                            remote
                            placeholder="Digite o nome da empresa"
                            :remote-method="getEmpresa"
                            :loading="loadingEmpresa"
                            value-key="id"
                            @change="salvar('ruleForm')"
                        >
                        <el-option
                            v-for="item in lstEmpresa"
                            :key="item.id"
                            :value="item"
                            :label="item.nome"
                        >
                            <div class="col-md-12" style="float: left">
                                  <b>{{ item.nome }}</b>
                            </div>
                            <div class="col-md-12" style="float: left; color: #8492a6; font-size: 13px">
                                  {{item.cnpj}}
                            </div>

                        </el-option>

                      </el-select>

                      <div v-if="error['empresa']" class="el-form-item__error">{{error['empresa'][0]}}</div>

                  </el-form-item>
              </div>

              <div class="form-group col-md-12" style="margin-top:15px">

                <TableView
                      :pagination="pagination"
                      :tableData="tableData"
                      :tableHead="tableHead"
                      :loadingTable="loadingTable"
                      :onRegister="null"
                      :onEdit="null"
                      :response="response"
                      :onDelete="onDelete"
                      :onSearch="getEsocialCertificado"
                    >
                </TableView>
              </div>
            </div>
          </el-form>
			</div>
    </ed-modal>
        

    </div>
</template>

<script>

    import TableView from 'common/table'
    import Rest from 'common/rest'
    import Fct from 'common/fct'
    import EdModal from 'common/modal'

    export default {
        name:"esocial-certificado",
        mixins:[Rest],
        components:{TableView,EdModal},

        props:{

          certificado:{
            type:Object,
            default:function () { return {} }
          },

          showForm:{
            type:Boolean,
            default:function () { return false }
          }

        },


        watch:{

          certificado(){

          },

          showForm(){
            this.showFormEdit = !this.showFormEdit;
            this.getEsocialCertificado();
          }
        },

        data () {
          return {
            formData:{
              id_esocial_certificado:null,
              empresa:null
            },
            loadingTable:false,
            loadingSave:false,
            loadingEmpresa:false,
            showFormEdit:false,
            pagination:{},
            error:{},
            response:{},
            arquivo:null,
            tableHead:[
              {
                key: 'empresa',
						    sortable: true,
						    label: 'Empresa',
              }
            ],
            tableData:[],
            lstEmpresa:[]
          }
        },

        created(){
        },

        mounted() {
          this.getEsocialCertificado();
        },

        methods:{

            onDelete: function(data){

                var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

                self.loadingTable = true;

                this.post('/esocial/certificados/'+this.certificado.id+'/deletar/vinculo',{ids:data}).then((result)=>{
                    result = result[0];

                    self.loadingTable = false;

                    if(result.status == 200){

                          this.$message({
                            message: 'Registo excluido com sucesso',
                            type: 'success'
                          });

                          this.formataLista(result);

                        }
                    else{
                        if(result.status == 403){
                            this.$alert('Você não possui permissão para deletar esse registro', 'Atenção', {
                                confirmButtonText: 'OK'
                            });
                        }
                        else{
                          this.$message({
                            message: result.msg,
                            type: 'error'
                          });
                        }
                    }

                });

              });
            },

            getEmpresa: function(_search,_id){

                this.loadingEmpresa = true;

                var url = '';

                this.get('/empresa',{search:_search}).then((result)=>{

                    result = result[0];

                    if(result.status == 200){
                        this.lstEmpresa = result.data.data;
                    }

                    this.loadingEmpresa = false;
                });
            },

            getEsocialCertificado(_search,_page){

                this.loadingTable = true;
                this.lstTabelaConteudo = [];
                this.hideAdvancedFilter = !this.hideAdvancedFilter;
                this.formData.certificado = this.certificado;
                this.response = {};
                this.pagination = {}

                this.get('/esocial/certificados/'+this.certificado.id,{page:_page,search:_search,pagination:20}).then((result)=>{

                    result = result[0];

                    this.loadingTable = false;
                    this.response = result;
                    this.pagination = result

                    if(result.status == 200){
                      this.formataLista(result);
                    }
                });
            },

            formataLista: function(result){

              var tableData = [], arrData = result.data.data;

              for (var i = 0; i < arrData.length; i++) {

                var item = {
                  'empresa':arrData[i].empresa_cnpj+' - '+arrData[i].empresa_nome_fantasia,
                  _data:arrData[i],
                  buttons:[],
                  options:{}
                };

                tableData.push(item);
              }

              this.tableData = tableData;
              this.pagination = result.data;
            },

            salvar: function(formName){

              this.$refs[formName].validate((valid) => {

                  if(valid) {

                    this.loadingTable = true;
                    this.error = {};

                    this.post('/esocial/certificados/'+this.certificado.id+'/vincular',this.formData).then((result)=>{

                      this.loadingTable = false;

                      result = result[0];

                      if(result.status == 200){

                        this.$message({
                          message: 'Dados atualizados com sucesso',
                          type: 'success'
                        });

                        this.lstEmpresa = [];
                        this.formData.empresa = null;

                        this.formataLista(result);
                      }
                    });
                  }
                  else{
                      this.$alert('Antes de processeguir, por favor preencher todos os campos obrigatórios', 'Atenção', {
                        confirmButtonText: 'OK'
                      });
                  }
              });

            }

        }
    }
</script>



// WEBPACK FOOTER //
// vincular.vue?ac0f5638